import { render } from "./chevron-down-new.vue?vue&type=template&id=315adde8&ts=true"
import script from "./chevron-down-new.vue?vue&type=script&lang=ts"
export * from "./chevron-down-new.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__